import styled from 'styled-components';

const styles = {};

export default styles;

export const Container = styled.div`
  display: flex;
  align-items: center;
`;
export const PieChart = styled.div`
  width: 160px;
  height: 160px;
`;

export const Legend = styled.div``;

export const LegendText = styled.span``;
